/** Query flag that clears shared session-scoped Site/Dept/Unit filters (REBUILD-396). */
export const CLEAR_ORG_FILTERS_PARAM = 'clear_org_filters'

export const clearOrgFiltersParams = (): Record<string, string> => ({
  [CLEAR_ORG_FILTERS_PARAM]: '1',
})

/**
 * Append array-style org filter params (`site_id[]`, …).
 * Always writes each key (empty marker when none) so the server can distinguish
 * apply/deselect from bare tab navigation without org keys.
 */
export const appendArrayOrgFilterParams = (
  params: URLSearchParams,
  filters: { siteIds: number[]; departmentIds: number[]; unitIds: number[] },
): void => {
  const appendDimension = (key: string, ids: number[]) => {
    if (ids.length > 0) {
      ids.forEach((id) => params.append(key, String(id)))
    } else {
      params.append(key, '')
    }
  }

  appendDimension('site_id[]', filters.siteIds)
  appendDimension('department_id[]', filters.departmentIds)
  appendDimension('unit_id[]', filters.unitIds)
}
